module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes,
    attrs: {
      "id": _vm.id
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15085b34","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/ui/components/tabs/TabsContent.vue
// module id = 285
// module chunks = 1